import { SorterResult } from 'antd/lib/table/interface';
import { IFBAccount } from 'services/rtk/fbmanager/types/account';
import { IAd } from 'services/rtk/fbmanager/types/ad';
import { IAdset } from 'services/rtk/fbmanager/types/adset';
import { ICab } from 'services/rtk/fbmanager/types/cab';
import { ICampaign } from 'services/rtk/fbmanager/types/campaign';
import { IFBUser } from 'services/rtk/fbmanager/types/user';

import { IFBmanagerTableName } from './table-settings/reducer';

export enum FBManagerActionTypes {
  SET_CURRENT_MENU_POSITION = 'SET_CURRENT_MENU_POSITION',

  SELECT_USERS_ROWS = 'SELECT_USERS_ROWS',
  UNSELECT_USERS_ROWS = 'UNSELECT_USERS_ROWS',
  CLEAR_SELECTED_USERS = 'CLEAR_SELECTED_USERS',
  SET_SELECTED_USERS = 'SET_SELECTED_USERS',
  UNSET_SELECTED_USERS = 'UNSET_SELECTED_USERS',
  UPDATE_SELECTED_USERS = 'UPDATE_SELECTED_USERS',

  SELECT_ACCOUNTS_ROWS_IDS = 'SELECT_ACCOUNTS_ROWS_IDS',
  UNSELECT_ACCOUNTS_ROWS_IDS = 'UNSELECT_ACCOUNTS_ROWS_IDS',
  CLEAR_SELECTED_ACCOUNTS_ROWS_IDS = 'CLEAR_SELECTED_ACCOUNTS_ROWS_IDS',
  SET_SELECTED_ACCOUNTS = 'SET_SELECTED_ACCOUNTS',
  UNSET_SELECTED_ACCOUNTS = 'UNSET_SELECTED_ACCOUNTS',
  UPDATE_SELECTED_ACCOUNTS = 'UPDATE_SELECTED_ACCOUNTS',

  SELECT_CABS_ROWS_IDS = 'SELECT_CABS_ROWS_IDS',
  UNSELECT_CABS_ROWS_IDS = 'UNSELECT_CABS_ROWS_IDS',
  CLEAR_SELECTED_CABS_ROWS_IDS = 'CLEAR_SELECTED_CABS_ROWS_IDS',
  SET_SELECTED_CABS = 'SET_SELECTED_CABS',
  UNSET_SELECTED_CABS = 'UNSET_SELECTED_CABS',
  UPDATE_SELECTED_CABS = 'UPDATE_SELECTED_CABS',

  SELECT_CAMPAIGNS_ROWS = 'SELECT_CAMPAIGNS_ROWS',
  UNSELECT_CAMPAIGNS_ROWS = 'UNSELECT_CAMPAIGNS_ROWS',
  CLEAR_SELECTED_CAMPAIGNS = 'CLEAR_SELECTED_CAMPAIGNS',
  SET_SELECTED_CAMPAIGNS = 'SET_SELECTED_CAMPAIGNS',
  UNSET_SELECTED_CAMPAIGNS = 'UNSET_SELECTED_CAMPAIGNS',
  UPDATE_SELECTED_CAMPAIGNS = 'UPDATE_SELECTED_CAMPAIGNS',

  SELECT_ADSETS_ROWS = 'SELECT_ADSETS_ROWS',
  UNSELECT_ADSETS_ROWS = 'UNSELECT_ADSETS_ROWS',
  CLEAR_SELECTED_ADSETS = 'CLEAR_SELECTED_ADSETS',
  SET_SELECTED_ADSETS = 'SET_SELECTED_ADSETS',
  UNSET_SELECTED_ADSETS = 'UNSET_SELECTED_ADSETS',
  UPDATE_SELECTED_ADSETS = 'UPDATE_SELECTED_ADSETS',

  SELECT_ADS_ROWS = 'SELECT_ADS_ROWS',
  UNSELECT_ADS_ROWS = 'UNSELECT_ADS_ROWS',
  CLEAR_SELECTED_ADS = 'CLEAR_SELECTED_ADS',
  SET_SELECTED_ADS = 'SET_SELECTED_ADS',
  UNSET_SELECTED_ADS = 'UNSET_SELECTED_ADS',
  UPDATE_SELECTED_ADS = 'UPDATE_SELECTED_ADS',

  REFRESH_TABLES = 'REFRESH_TABLES',
  SET_SORT = 'SET_SORT',
  SET_WITH_SPENT = 'SET_WITH_SPENT',

  SET_DUPLICATE_COUNTER = 'SET_DUPLICATE_COUNTER',

  SET_USERS_PAGE = 'SET_USERS_PAGE',
  SET_ACCOUNTS_PAGE = 'SET_ACCOUNTS_PAGE',
  SET_CABS_PAGE = 'SET_CABS_PAGE',
  SET_CAMPAIGNS_PAGE = 'SET_CAMPAIGNS_PAGE',
  SET_ADSETS_PAGE = 'SET_ADSETS_PAGE',
  SET_ADS_PAGE = 'SET_ADS_PAGE',

  SET_SEARCH_USERS = 'SET_SEARCH_USERS',
  SET_SEARCH_ACCOUNTS = 'SET_SEARCH_ACCOUNTS',
  SET_SEARCH_CABS = 'SET_SEARCH_CABS',
  SET_SEARCH_CAMPAIGNS = 'SET_SEARCH_CAMPAIGNS',
  SET_SEARCH_ADSETS = 'SET_SEARCH_ADSETS',
  SET_SEARCH_ADS = 'SET_SEARCH_ADS',
}

interface ISetCurrentMenuPositionAction {
  type: FBManagerActionTypes.SET_CURRENT_MENU_POSITION;
  payload: IFBmanagerTableName;
}

interface ISelectUsersRowsAction {
  type: FBManagerActionTypes.SELECT_USERS_ROWS;
  payload: number[];
}

interface IUnselectUsersRowsAction {
  type: FBManagerActionTypes.UNSELECT_USERS_ROWS;
  payload: number[];
}

interface IClearSelectedUsersAction {
  type: FBManagerActionTypes.CLEAR_SELECTED_USERS;
}

interface ISetSelectedUsers {
  type: FBManagerActionTypes.SET_SELECTED_USERS;
  payload: IFBUser[];
}

interface IUnsetSelectedUsers {
  type: FBManagerActionTypes.UNSET_SELECTED_USERS;
  payload: IFBUser[];
}

interface IUpdateSelectedUsers {
  type: FBManagerActionTypes.UPDATE_SELECTED_USERS;
  payload: IFBUser[] | undefined;
}

interface ISelectAccountsRowsAction {
  type: FBManagerActionTypes.SELECT_ACCOUNTS_ROWS_IDS;
  payload: number[];
}

interface IUnselectAccountsRowsAction {
  type: FBManagerActionTypes.UNSELECT_ACCOUNTS_ROWS_IDS;
  payload: number[];
}

interface IClearSelectedAccountsAction {
  type: FBManagerActionTypes.CLEAR_SELECTED_ACCOUNTS_ROWS_IDS;
}

interface ISetSelectedAccounts {
  type: FBManagerActionTypes.SET_SELECTED_ACCOUNTS;
  payload: IFBAccount[];
}

interface IUnsetSelectedAccounts {
  type: FBManagerActionTypes.UNSET_SELECTED_ACCOUNTS;
  payload: IFBAccount[];
}

interface IUpdateSelectedAccounts {
  type: FBManagerActionTypes.UPDATE_SELECTED_ACCOUNTS;
  payload: IFBAccount[] | undefined;
}

interface ISelectCabsRowsAction {
  type: FBManagerActionTypes.SELECT_CABS_ROWS_IDS;
  payload: number[];
}

interface IUnselectCabsRowsAction {
  type: FBManagerActionTypes.UNSELECT_CABS_ROWS_IDS;
  payload: number[];
}

interface IClearSelectedCabsAction {
  type: FBManagerActionTypes.CLEAR_SELECTED_CABS_ROWS_IDS;
}

interface ISetSelectedCabs {
  type: FBManagerActionTypes.SET_SELECTED_CABS;
  payload: ICab[];
}

interface IUnsetSelectedCabs {
  type: FBManagerActionTypes.UNSET_SELECTED_CABS;
  payload: ICab[];
}

interface IUpdateSelectedCabs {
  type: FBManagerActionTypes.UPDATE_SELECTED_CABS;
  payload: ICab[] | undefined;
}

interface ISelectCampaignsRowsAction {
  type: FBManagerActionTypes.SELECT_CAMPAIGNS_ROWS;
  payload: number[];
}

interface IUnselectCampaignsRowsAction {
  type: FBManagerActionTypes.UNSELECT_CAMPAIGNS_ROWS;
  payload: number[];
}

interface IClearSelectedCampaignsAction {
  type: FBManagerActionTypes.CLEAR_SELECTED_CAMPAIGNS;
}

interface ISetSelectedCampaigns {
  type: FBManagerActionTypes.SET_SELECTED_CAMPAIGNS;
  payload: ICampaign[];
}

interface IUnsetSelectedCampaigns {
  type: FBManagerActionTypes.UNSET_SELECTED_CAMPAIGNS;
  payload: ICampaign[];
}

interface IUpdateSelectedCampaigns {
  type: FBManagerActionTypes.UPDATE_SELECTED_CAMPAIGNS;
  payload: ICampaign[] | undefined;
}

interface ISelectAdsetsRowsAction {
  type: FBManagerActionTypes.SELECT_ADSETS_ROWS;
  payload: number[];
}

interface IUnselectAdsetsRowsAction {
  type: FBManagerActionTypes.UNSELECT_ADSETS_ROWS;
  payload: number[];
}

interface IClearSelectedAdsetsAction {
  type: FBManagerActionTypes.CLEAR_SELECTED_ADSETS;
}

interface ISetSelectedAdsets {
  type: FBManagerActionTypes.SET_SELECTED_ADSETS;
  payload: IAdset[];
}

interface IUnsetSelectedAdsets {
  type: FBManagerActionTypes.UNSET_SELECTED_ADSETS;
  payload: IAdset[];
}

interface IUpdateSelectedAdsets {
  type: FBManagerActionTypes.UPDATE_SELECTED_ADSETS;
  payload: IAdset[] | undefined;
}

interface ISelectAdsRowsAction {
  type: FBManagerActionTypes.SELECT_ADS_ROWS;
  payload: number[];
}

interface IUnselectAdsRowsAction {
  type: FBManagerActionTypes.UNSELECT_ADS_ROWS;
  payload: number[];
}

interface IClearSelectedAdsAction {
  type: FBManagerActionTypes.CLEAR_SELECTED_ADS;
}

interface ISetSelectedAds {
  type: FBManagerActionTypes.SET_SELECTED_ADS;
  payload: IAd[];
}

interface IUnsetSelectedAds {
  type: FBManagerActionTypes.UNSET_SELECTED_ADS;
  payload: IAd[];
}

interface IUpdateSelectedAds {
  type: FBManagerActionTypes.UPDATE_SELECTED_ADS;
  payload: IAd[] | undefined;
}

interface IRefreshTables {
  type: FBManagerActionTypes.REFRESH_TABLES;
}

interface ISetWithSpentAction {
  type: FBManagerActionTypes.SET_WITH_SPENT;
  payload: boolean;
}

interface ISetDuplicateCounterAction {
  type: FBManagerActionTypes.SET_DUPLICATE_COUNTER;
  payload: number | null;
}

interface ISetSearchUsersAction {
  type: FBManagerActionTypes.SET_SEARCH_USERS;
  payload: string;
}

interface ISetSearchAccountsAction {
  type: FBManagerActionTypes.SET_SEARCH_ACCOUNTS;
  payload: string;
}

interface ISetSearchCabsAction {
  type: FBManagerActionTypes.SET_SEARCH_CABS;
  payload: string;
}

interface ISetSearchCampaignsAction {
  type: FBManagerActionTypes.SET_SEARCH_CAMPAIGNS;
  payload: string;
}

interface ISetSearchAdsetsAction {
  type: FBManagerActionTypes.SET_SEARCH_ADSETS;
  payload: string;
}

interface ISetSearchAdsAction {
  type: FBManagerActionTypes.SET_SEARCH_ADS;
  payload: string;
}

interface ISetUsersPageAction {
  type: FBManagerActionTypes.SET_USERS_PAGE;
  payload: number;
}

interface ISetAccountsPageAction {
  type: FBManagerActionTypes.SET_ACCOUNTS_PAGE;
  payload: number;
}

interface ISetCabsPageAction {
  type: FBManagerActionTypes.SET_CABS_PAGE;
  payload: number;
}

interface ISetCampaignsPageAction {
  type: FBManagerActionTypes.SET_CAMPAIGNS_PAGE;
  payload: number;
}

interface ISetAdsetsPageAction {
  type: FBManagerActionTypes.SET_ADSETS_PAGE;
  payload: number;
}

interface ISetAdsPageAction {
  type: FBManagerActionTypes.SET_ADS_PAGE;
  payload: number;
}

interface ISetSort {
  type: FBManagerActionTypes.SET_SORT;
  payload:
    | SorterResult<IFBUser>
    | SorterResult<IFBAccount>
    | SorterResult<IAd>
    | SorterResult<IAdset>
    | SorterResult<ICab>
    | SorterResult<ICampaign>;
}

export type TFBManagerActions =
  | ISetCurrentMenuPositionAction
  | ISelectUsersRowsAction
  | IUnselectUsersRowsAction
  | IClearSelectedUsersAction
  | ISetSelectedUsers
  | IUnsetSelectedUsers
  | IUpdateSelectedUsers
  | ISelectAccountsRowsAction
  | IUnselectAccountsRowsAction
  | IClearSelectedAccountsAction
  | ISetSelectedAccounts
  | IUnsetSelectedAccounts
  | IUpdateSelectedAccounts
  | ISelectCabsRowsAction
  | IUnselectCabsRowsAction
  | IClearSelectedCabsAction
  | ISetSelectedCabs
  | IUnsetSelectedCabs
  | IUpdateSelectedCabs
  | ISelectCampaignsRowsAction
  | IUnselectCampaignsRowsAction
  | IClearSelectedCampaignsAction
  | ISetSelectedCampaigns
  | IUnsetSelectedCampaigns
  | IUpdateSelectedCampaigns
  | ISelectAdsetsRowsAction
  | IUnselectAdsetsRowsAction
  | IClearSelectedAdsetsAction
  | ISetSelectedAdsets
  | IUnsetSelectedAdsets
  | IUpdateSelectedAdsets
  | ISelectAdsRowsAction
  | IUnselectAdsRowsAction
  | IClearSelectedAdsAction
  | ISetSelectedAds
  | IUnsetSelectedAds
  | IUpdateSelectedAds
  | IRefreshTables
  | ISetSort
  | ISetWithSpentAction
  | ISetDuplicateCounterAction
  | ISetSearchUsersAction
  | ISetSearchAccountsAction
  | ISetSearchCabsAction
  | ISetSearchCampaignsAction
  | ISetSearchAdsetsAction
  | ISetSearchAdsAction
  | ISetUsersPageAction
  | ISetAccountsPageAction
  | ISetCabsPageAction
  | ISetCampaignsPageAction
  | ISetAdsetsPageAction
  | ISetAdsPageAction;

export const setCurrentMenuPosition = (payload: IFBmanagerTableName): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_CURRENT_MENU_POSITION,
  payload,
});

export const selectUserRows = (payload: number[]): TFBManagerActions => ({
  type: FBManagerActionTypes.SELECT_USERS_ROWS,
  payload,
});

export const unselectUserRows = (payload: number[]): TFBManagerActions => ({
  type: FBManagerActionTypes.UNSELECT_USERS_ROWS,
  payload,
});

export const clearSelectedUsers = (): TFBManagerActions => ({
  type: FBManagerActionTypes.CLEAR_SELECTED_USERS,
});

export const setSelectedUsers = (payload: IFBUser[]): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_SELECTED_USERS,
  payload,
});

export const unsetSelectedUsers = (payload: IFBUser[]): TFBManagerActions => ({
  type: FBManagerActionTypes.UNSET_SELECTED_USERS,
  payload,
});

export const updateSelectedUsers = (payload: IFBUser[] | undefined): TFBManagerActions => ({
  type: FBManagerActionTypes.UPDATE_SELECTED_USERS,
  payload,
});

export const selectAccountRowsIds = (payload: number[]): TFBManagerActions => ({
  type: FBManagerActionTypes.SELECT_ACCOUNTS_ROWS_IDS,
  payload,
});

export const unselectAccountRowsIds = (payload: number[]): TFBManagerActions => ({
  type: FBManagerActionTypes.UNSELECT_ACCOUNTS_ROWS_IDS,
  payload,
});

export const clearSelectedAccountsIds = (): TFBManagerActions => ({
  type: FBManagerActionTypes.CLEAR_SELECTED_ACCOUNTS_ROWS_IDS,
});

export const setSelectedAccounts = (payload: IFBAccount[]): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_SELECTED_ACCOUNTS,
  payload,
});

export const unsetSelectedAccounts = (payload: IFBAccount[]): TFBManagerActions => ({
  type: FBManagerActionTypes.UNSET_SELECTED_ACCOUNTS,
  payload,
});

export const updateSelectedAccounts = (payload: IFBAccount[] | undefined): TFBManagerActions => ({
  type: FBManagerActionTypes.UPDATE_SELECTED_ACCOUNTS,
  payload,
});

export const selectCabRows = (payload: number[]): TFBManagerActions => ({
  type: FBManagerActionTypes.SELECT_CABS_ROWS_IDS,
  payload,
});

export const unselectCabRows = (payload: number[]): TFBManagerActions => ({
  type: FBManagerActionTypes.UNSELECT_CABS_ROWS_IDS,
  payload,
});

export const clearSelectedCabs = (): TFBManagerActions => ({
  type: FBManagerActionTypes.CLEAR_SELECTED_CABS_ROWS_IDS,
});

export const setSelectedCabs = (payload: ICab[]): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_SELECTED_CABS,
  payload,
});

export const unsetSelectedCabs = (payload: ICab[]): TFBManagerActions => ({
  type: FBManagerActionTypes.UNSET_SELECTED_CABS,
  payload,
});

export const updateSelectedCabs = (payload: ICab[] | undefined): TFBManagerActions => ({
  type: FBManagerActionTypes.UPDATE_SELECTED_CABS,
  payload,
});

export const selectCampaignRows = (payload: number[]): TFBManagerActions => ({
  type: FBManagerActionTypes.SELECT_CAMPAIGNS_ROWS,
  payload,
});

export const unselectCampaignRows = (payload: number[]): TFBManagerActions => ({
  type: FBManagerActionTypes.UNSELECT_CAMPAIGNS_ROWS,
  payload,
});

export const clearSelectedCampaigns = (): TFBManagerActions => ({
  type: FBManagerActionTypes.CLEAR_SELECTED_CAMPAIGNS,
});

export const setSelectedCampaigns = (payload: ICampaign[]): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_SELECTED_CAMPAIGNS,
  payload,
});

export const unsetSelectedCampaigns = (payload: ICampaign[]): TFBManagerActions => ({
  type: FBManagerActionTypes.UNSET_SELECTED_CAMPAIGNS,
  payload,
});

export const updateSelectedCampaigns = (payload: ICampaign[] | undefined): TFBManagerActions => ({
  type: FBManagerActionTypes.UPDATE_SELECTED_CAMPAIGNS,
  payload,
});

export const selectAdsetRows = (payload: number[]): TFBManagerActions => ({
  type: FBManagerActionTypes.SELECT_ADSETS_ROWS,
  payload,
});

export const unselectAdsetRows = (payload: number[]): TFBManagerActions => ({
  type: FBManagerActionTypes.UNSELECT_ADSETS_ROWS,
  payload,
});

export const clearSelectedAdsets = (): TFBManagerActions => ({
  type: FBManagerActionTypes.CLEAR_SELECTED_ADSETS,
});

export const setSelectedAdsets = (payload: IAdset[]): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_SELECTED_ADSETS,
  payload,
});

export const unsetSelectedAdsets = (payload: IAdset[]): TFBManagerActions => ({
  type: FBManagerActionTypes.UNSET_SELECTED_ADSETS,
  payload,
});

export const updateSelectedAdsets = (payload: IAdset[] | undefined): TFBManagerActions => ({
  type: FBManagerActionTypes.UPDATE_SELECTED_ADSETS,
  payload,
});

export const selectAdRows = (payload: number[]): TFBManagerActions => ({
  type: FBManagerActionTypes.SELECT_ADS_ROWS,
  payload,
});

export const unselectAdRows = (payload: number[]): TFBManagerActions => ({
  type: FBManagerActionTypes.UNSELECT_ADS_ROWS,
  payload,
});

export const clearSelectedAds = (): TFBManagerActions => ({
  type: FBManagerActionTypes.CLEAR_SELECTED_ADS,
});

export const setSelectedAds = (payload: IAd[]): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_SELECTED_ADS,
  payload,
});

export const unsetSelectedAds = (payload: IAd[]): TFBManagerActions => ({
  type: FBManagerActionTypes.UNSET_SELECTED_ADS,
  payload,
});

export const updateSelectedAds = (payload: IAd[] | undefined): TFBManagerActions => ({
  type: FBManagerActionTypes.UPDATE_SELECTED_ADS,
  payload,
});

export const refreshTables = (): TFBManagerActions => ({
  type: FBManagerActionTypes.REFRESH_TABLES,
});

export interface ISort {
  field: string;
  order: 'descend' | 'ascend';
}

export const setSortAction = (
  payload:
    | SorterResult<IFBUser>
    | SorterResult<IFBAccount>
    | SorterResult<IAd>
    | SorterResult<IAdset>
    | SorterResult<ICab>
    | SorterResult<ICampaign>
): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_SORT,
  payload,
});

export const setWithSpent = (payload: boolean): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_WITH_SPENT,
  payload,
});

export const setDuplicateCounter = (payload: number | null): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_DUPLICATE_COUNTER,
  payload,
});

export const setSearchFbUsers = (payload: string): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_SEARCH_USERS,
  payload,
});

export const setSearchFbAccounts = (payload: string): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_SEARCH_ACCOUNTS,
  payload,
});

export const setSearchFbCabs = (payload: string): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_SEARCH_CABS,
  payload,
});

export const setSearchFbCampaigns = (payload: string): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_SEARCH_CAMPAIGNS,
  payload,
});

export const setSearchFbAdsets = (payload: string): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_SEARCH_ADSETS,
  payload,
});

export const setSearchFbAds = (payload: string): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_SEARCH_ADS,
  payload,
});

export const setFbUsersPage = (payload: number): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_USERS_PAGE,
  payload,
});

export const setFbAccountsPage = (payload: number): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_ACCOUNTS_PAGE,
  payload,
});

export const setFbCabsPage = (payload: number): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_CABS_PAGE,
  payload,
});

export const setFbCampaignsPage = (payload: number): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_CAMPAIGNS_PAGE,
  payload,
});

export const setFbAdsetsPage = (payload: number): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_ADSETS_PAGE,
  payload,
});

export const setFbAdsPage = (payload: number): TFBManagerActions => ({
  type: FBManagerActionTypes.SET_ADS_PAGE,
  payload,
});
